(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sprz-wow-pdp-collection"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var SECTION_SELECTOR = '[data-sprz-collection]';

      function initCollection(root) {
        if (root.dataset.sprzCollectionInit === 'true') return;
        root.dataset.sprzCollectionInit = 'true';

        /* A story reveal-mintája: az observer a konténert figyeli (threshold
           0.2), a gyerekek CSS-delay-jel animálnak; reduced motion esetén
           azonnal látható minden */
        var container = root.querySelector('.sprz-wow-pdp-collection__container');
        if (!container) return;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          container.classList.add('is-revealed');
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                io.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );
        io.observe(container);
      }

      document.querySelectorAll(SECTION_SELECTOR).forEach(initCollection);
      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll(SECTION_SELECTOR).forEach(initCollection);
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sprz-wow-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION_SELECTOR = '[data-sprz-hero]';

    function initHero(root) {
      if (root.dataset.sprzHeroInit === 'true') return;
      root.dataset.sprzHeroInit = 'true';

      /* Thumbnail-váltás — láthatóság-kapcsolás a data-sprz-media-index alapján,
         így a képek mellett a videók is megjelenhetnek a fő média területen */
      var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-sprz-media-index]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sprz-thumb]'));
      var activeIndex = 0;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = parseInt(btn.dataset.sprzThumbIndex, 10);
          if (isNaN(target) || target === activeIndex) return;
          mediaItems.forEach(function (item) {
            var isTarget = parseInt(item.dataset.sprzMediaIndex, 10) === target;
            if (!isTarget) {
              var video = item.querySelector('video');
              if (video && !video.paused) video.pause();
            }
            item.hidden = !isTarget;
          });
          activeIndex = target;
          thumbs.forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
        });
      });

      /* Videó play-overlay — a natív vezérlősáv érintetlen marad, a gomb csak
         a lejátszás indításáig látszik, szünet/vég után újra megjelenik */
      Array.prototype.slice.call(root.querySelectorAll('[data-sprz-video-play]')).forEach(function (playBtn) {
        var wrapper = playBtn.closest('.sprz-wow-pdp-hero__media-item');
        var video = wrapper ? wrapper.querySelector('video') : null;
        if (!video) return;
        playBtn.addEventListener('click', function () {
          playBtn.hidden = true;
          /* preload="none" miatt indulaskor nincs betoltott adat; a load()
             nelkul a play() egyes bongeszokben (Safari/iOS) elutasitva erkezik */
          if (video.readyState === 0) video.load();
          var started = video.play();
          if (started && typeof started.catch === 'function') {
            started.catch(function () {
              playBtn.hidden = false;
            });
          }
        });
        video.addEventListener('play', function () {
          playBtn.hidden = true;
        });
        video.addEventListener('pause', function () {
          playBtn.hidden = false;
        });
        video.addEventListener('ended', function () {
          playBtn.hidden = false;
        });
      });

      /* Mennyiség-stepper (min 1) */
      var qtyInput = root.querySelector('[data-sprz-qty-input]');
      var minusBtn = root.querySelector('[data-sprz-qty-minus]');
      var plusBtn = root.querySelector('[data-sprz-qty-plus]');
      function step(delta) {
        if (!qtyInput) return;
        var current = parseInt(qtyInput.value, 10);
        if (isNaN(current)) current = 1;
        qtyInput.value = Math.max(1, current + delta);
      }
      if (minusBtn) minusBtn.addEventListener('click', function () { step(-1); });
      if (plusBtn) plusBtn.addEventListener('click', function () { step(1); });
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          var current = parseInt(qtyInput.value, 10);
          if (isNaN(current) || current < 1) qtyInput.value = 1;
        });
      }

      /* Reveal — a v6 useReveal mintája (threshold 0.15, reduced motion tisztelet) */
      var revealEls = root.querySelectorAll('[data-sprz-reveal]');
      if (revealEls.length) {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          revealEls.forEach(function (el) {
            el.classList.add('is-revealed');
          });
        } else {
          var io = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-revealed');
                  io.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.15 }
          );
          revealEls.forEach(function (el) {
            io.observe(el);
          });
        }
      }
    }

    document.querySelectorAll(SECTION_SELECTOR).forEach(initHero);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll(SECTION_SELECTOR).forEach(initHero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sprz-wow-pdp-pyramid"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var SECTION_SELECTOR = '[data-sprz-pyramid]';

      function initPyramid(root) {
        if (root.dataset.sprzPyramidInit === 'true') return;
        root.dataset.sprzPyramidInit = 'true';

        /* A v6 interakciós modell: kattintás rétegre VAGY kártyára → az a tier
           aktív (setActive). Hover tisztán CSS; nincs egyéb JS-animáció, így
           reduced motion mellett sincs mit kikapcsolni (a transitionök a CSS
           reduce-blokkban állnak le). */
        var layers = root.querySelectorAll('[data-tier-trigger]');
        var panels = root.querySelectorAll('[data-tier-panel]');
        if (!layers.length || !panels.length) return;

        function setActive(tier) {
          layers.forEach(function (btn) {
            var on = btn.dataset.tier === tier;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            var on = panel.dataset.tier === tier;
            panel.classList.toggle('is-active', on);
            var panelBtn = panel.querySelector('[data-tier-panel-btn]');
            if (panelBtn) panelBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }

        layers.forEach(function (btn) {
          btn.addEventListener('click', function () {
            setActive(btn.dataset.tier);
          });
        });
        /* A teljes kártya kattintható (a v6-ban a div-en van onClick); a belső
           gomb kattintása felbuborékol ugyanide — kétszeres setActive ártalmatlan */
        panels.forEach(function (panel) {
          panel.addEventListener('click', function () {
            setActive(panel.dataset.tier);
          });
        });
      }

      document.querySelectorAll(SECTION_SELECTOR).forEach(initPyramid);
      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll(SECTION_SELECTOR).forEach(initPyramid);
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sprz-wow-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var SECTION_SELECTOR = '[data-sprz-reviews]';

      function initReviews(root) {
        if (root.dataset.sprzReviewsInit === 'true') return;
        root.dataset.sprzReviewsInit = 'true';

        var distWrap = root.querySelector('[data-sprz-dist]');
        var distList = root.querySelector('[data-sprz-dist-list]');
        var widgetWrap = root.querySelector('[data-sprz-widget]');
        /* Nincs összegző (nincs rating) vagy nincs widget → nincs teendő */
        if (!distWrap || !distList || !widgetWrap) return;

        function parseIntSafe(text) {
          if (!text) return NaN;
          var m = String(text).replace(/[\s,.]/g, '').match(/\d+/);
          return m ? parseInt(m[0], 10) : NaN;
        }

        /* A Judge.me hisztogram-sor defenzív olvasása: rating a data-rating
           attribútumból (fallback: a sor szövegének első számjegye),
           darabszám a __frequency cellából, százalék a __percentage cellából
           vagy a sáv inline width-jéből. Ha a struktúra más, null megy
           vissza, és a sávok egyszerűen nem épülnek fel. */
        function readRow(row) {
          var rating = parseInt(row.getAttribute('data-rating'), 10);
          if (!(rating >= 1 && rating <= 5)) {
            var starEl = row.querySelector('.jdgm-histogram__star');
            rating = parseIntSafe(starEl ? starEl.textContent : row.textContent);
          }
          if (!(rating >= 1 && rating <= 5)) return null;

          var freqEl = row.querySelector('.jdgm-histogram__frequency');
          var count = parseIntSafe(freqEl ? freqEl.textContent : '');

          var pct = NaN;
          var pctEl = row.querySelector('.jdgm-histogram__percentage');
          if (pctEl) pct = parseFloat(pctEl.textContent);
          if (isNaN(pct)) {
            var barEl = row.querySelector('.jdgm-histogram__bar-content');
            if (barEl && barEl.style && barEl.style.width) {
              pct = parseFloat(barEl.style.width);
            }
          }
          if (isNaN(count) && isNaN(pct)) return null;
          return { rating: rating, count: count, pct: pct, sourceRow: row };
        }

        function buildBars(rows) {
          var data = [];
          rows.forEach(function (row) {
            var parsed = readRow(row);
            if (parsed) data.push(parsed);
          });
          if (!data.length) return false;

          /* Százalék: darabszámokból számolva, ha mind megvan (pontosabb);
             különben a widget saját százaléka/sáv-szélessége */
          var total = 0;
          var allCounts = true;
          data.forEach(function (d) {
            if (isNaN(d.count)) allCounts = false;
            else total += d.count;
          });
          data.forEach(function (d) {
            if (allCounts && total > 0) {
              d.pct = Math.round((d.count / total) * 100);
            } else {
              d.pct = Math.round(isNaN(d.pct) ? 0 : d.pct);
            }
          });

          /* 5 → 1 sorrend, mint a v6 DIST */
          data.sort(function (a, b) { return b.rating - a.rating; });

          data.forEach(function (d) {
            var li = document.createElement('li');
            li.className = 'sprz-wow-pdp-reviews__dist-item';

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'sprz-wow-pdp-reviews__dist-row';
            btn.setAttribute(
              'aria-label',
              'Show ' + d.rating + '-star reviews (' + d.pct + '%)'
            );

            var star = document.createElement('span');
            star.className = 'sprz-wow-pdp-reviews__dist-star';
            star.textContent = d.rating;

            var track = document.createElement('span');
            track.className = 'sprz-wow-pdp-reviews__dist-track';
            var fill = document.createElement('span');
            fill.className = 'sprz-wow-pdp-reviews__dist-fill';
            fill.style.display = 'block';
            fill.style.width = d.pct + '%';
            track.appendChild(fill);

            var pctLabel = document.createElement('span');
            pctLabel.className = 'sprz-wow-pdp-reviews__dist-pct';
            pctLabel.textContent = d.pct + '%';

            btn.appendChild(star);
            btn.appendChild(track);
            btn.appendChild(pctLabel);

            /* Kattintás: a widget saját (elrejtett) hisztogram-sorának
               click-je szűri a review-listát, majd görgetünk a widgethez */
            btn.addEventListener('click', function () {
              if (d.sourceRow && typeof d.sourceRow.click === 'function') {
                d.sourceRow.click();
              }
              var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              widgetWrap.scrollIntoView({
                behavior: reduced ? 'auto' : 'smooth',
                block: 'start'
              });
            });

            li.appendChild(btn);
            distList.appendChild(li);
          });

          distWrap.hidden = false;
          return true;
        }

        function tryBuild() {
          var rows = widgetWrap.querySelectorAll('.jdgm-histogram__row, .jdgm-histogram-row');
          if (!rows.length) return false;
          return buildBars(rows);
        }

        /* A widget aszinkron töltődik: MutationObserver várja a hisztogramot
           (fallback: polling); 30 mp után feladjuk — a kártya sávok nélkül,
           hibamentesen marad */
        if (tryBuild()) return;
        if ('MutationObserver' in window) {
          var mo = new MutationObserver(function () {
            if (tryBuild()) mo.disconnect();
          });
          mo.observe(widgetWrap, { childList: true, subtree: true });
          setTimeout(function () { mo.disconnect(); }, 30000);
        } else {
          var attempts = 0;
          var poll = setInterval(function () {
            attempts += 1;
            if (tryBuild() || attempts > 60) clearInterval(poll);
          }, 500);
        }
      }

      document.querySelectorAll(SECTION_SELECTOR).forEach(initReviews);
      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll(SECTION_SELECTOR).forEach(initReviews);
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sprz-wow-pdp-story"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var SECTION_SELECTOR = '[data-sprz-story]';

      function initStory(root) {
        if (root.dataset.sprzStoryInit === 'true') return;
        root.dataset.sprzStoryInit = 'true';

        /* A v6 useReveal mintája: az observer a konténert figyeli (threshold
           0.2), a gyerekek CSS-delay-jel animálnak; reduced motion esetén
           azonnal látható minden */
        var container = root.querySelector('.sprz-wow-pdp-story__container');
        if (!container) return;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          container.classList.add('is-revealed');
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                io.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );
        io.observe(container);
      }

      document.querySelectorAll(SECTION_SELECTOR).forEach(initStory);
      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll(SECTION_SELECTOR).forEach(initStory);
      });
    })();

  } catch(e) { console.error(e); }
})();
})();
